var l = Object.defineProperty;
var n = (r, t, e) => t in r ? l(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var i = (r, t, e) => n(r, typeof t != "symbol" ? t + "" : t, e);
import { transpose as c } from "../../transpose.js";
import { constructFrom as h } from "../../constructFrom.js";
const m = 10;
class u {
  constructor() {
    i(this, "subPriority", 0);
  }
  validate(t, e) {
    return !0;
  }
}
class I extends u {
  constructor(t, e, s, o, a) {
    super(), this.value = t, this.validateValue = e, this.setValue = s, this.priority = o, a && (this.subPriority = a);
  }
  validate(t, e) {
    return this.validateValue(t, this.value, e);
  }
  set(t, e, s) {
    return this.setValue(t, e, this.value, s);
  }
}
class S extends u {
  constructor() {
    super(...arguments);
    i(this, "priority", m);
    i(this, "subPriority", -1);
  }
  set(e, s) {
    return s.timestampIsSet ? e : h(e, c(e, Date));
  }
}
export {
  S as DateToSystemTimezoneSetter,
  u as Setter,
  I as ValueSetter
};
//# sourceMappingURL=Setter.js.map
